import type { OperationDto } from '@/shared/types';

export const combineOperationFrames = (
  firstFrame: OperationDto[],
  olderFrames: OperationDto[][]
): OperationDto[] => {
  if (!olderFrames.length) return firstFrame;

  const seen = new Set<string>();

  return [firstFrame, ...olderFrames]
    .flat()
    .filter(operation => {
      if (seen.has(operation.operaionid)) return false;
      seen.add(operation.operaionid);
      return true;
    })
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
};

export const countTrailingEmptyFrames = (
  frames: OperationDto[][],
  fromIndex = 0
): number => {
  let count = 0;

  for (let index = frames.length - 1; index >= fromIndex; index -= 1) {
    if (frames[index].length) break;
    count += 1;
  }

  return count;
};
